import { gql } from '@apollo/client';

const ARE_OPERATIONS_AVAILABLE = gql`
  query {
  areOperationsAvailable {
    areOperationsAvailable
    unavailabilityCode
  }
}
`;

export default ARE_OPERATIONS_AVAILABLE;
